import ROUTE_PATHS from "../routes/routePaths";

/**
 * Modules that are temporarily switched off for every user, including ADMIN.
 *
 * No page, component or API module is deleted - only the ways in are closed:
 *   1. the sidebar entries are filtered out (AppSidebar),
 *   2. the routes redirect away instead of rendering (AppRouter),
 *   3. the backend denies the matching endpoints (backend DisabledModules + SecurityConfig).
 *
 * HOW TO RE-ENABLE A MODULE
 * -------------------------
 * Remove its route paths from DISABLED_ROUTES below, and remove the matching patterns from
 * backend/src/main/java/mn/stusolution/sfg/config/DisabledModules.java. Nothing else changes.
 *
 * Currently disabled: Гүйлгээний хуваарь, Баланс, Хуулга, Байгууллагууд (and the screens
 * reachable only from them).
 */

/** Гүйлгээний хуваарь. */
const TRANSACTION_SCHEDULE_ROUTES = [
    ROUTE_PATHS.TRANSACTION_SCHEDULE,
    ROUTE_PATHS.TRANSACTION_SCHEDULE_DASHBOARD,
];

/** Баланс, plus the institution balance/wallet/analytics screens only reachable from it. */
const BALANCE_ROUTES = [
    ROUTE_PATHS.MANAGE_INSTITUTIONS,
    ROUTE_PATHS.INSTITUTION_ACCOUNTS,
    ROUTE_PATHS.INSTITUTION_HEAD_ACCOUNTS,
    ROUTE_PATHS.INSTITUTION_WALLETS,
    ROUTE_PATHS.INSTITUTION_ANALYTICS,
];

/** Хуулга, plus the statement search / account detail / statement upload screens behind it. */
const STATEMENT_ROUTES = [
    ROUTE_PATHS.TRANSACTION_DATA_TABLE,
    ROUTE_PATHS.SEARCH_STATEMENTS,
    ROUTE_PATHS.ACCOUNT_DETAIL,
    ROUTE_PATHS.ACCOUNT_STATEMENTS,
    ROUTE_PATHS.UPLOAD_EXCEL_ACC,
];

/** Байгууллагууд - institution list and its bank account management screen. */
const INSTITUTION_ROUTES = [
    ROUTE_PATHS.ADMIN_INSTITUTIONS,
    ROUTE_PATHS.ADMIN_ACCOUNTS,
];

export const DISABLED_ROUTES = [
    ...TRANSACTION_SCHEDULE_ROUTES,
    ...BALANCE_ROUTES,
    ...STATEMENT_ROUTES,
    ...INSTITUTION_ROUTES,
];

/** Where a user is sent when they try to open a disabled module. */
export const DISABLED_FALLBACK_ROUTE = ROUTE_PATHS.TRANSACTION_PLAN;

/** True when the given route path (a ROUTE_PATHS value) belongs to a disabled module. */
export function isRouteDisabled(routePath) {
    return DISABLED_ROUTES.includes(routePath);
}

/**
 * True when a browser location belongs to a disabled module. Handles the routes that carry
 * params, so /institutions/12/wallets is matched by "/institutions/:institutionId/wallets".
 */
export function isPathnameDisabled(pathname) {
    if (!pathname) return false;

    return DISABLED_ROUTES.some((routePath) => {
        const pattern = `^${routePath.replace(/:[^/]+/g, "[^/]+")}$`;
        return new RegExp(pattern).test(pathname);
    });
}
